 <template>
  <div class="page">
    <el-form
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="手机号">
       <el-input
            size="small"
            style="width: 200px"
            v-model="queryForm.phone"
        ></el-input>
      </el-form-item>
      <el-form-item label="时间">
          <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          >
       </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getBrandList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        团队数量：{{ idSet ? idSet : '--' }} 
      </div>
      <div class="page-tool-bar">
        总业绩： {{ totalMoney ? totalMoney : '--' }} 
      </div>
      <div class="page-tool-bar">
        线下业绩： {{ addMoney ? addMoney : '--' }} 
      </div>
      <div class="page-tool-bar">
        线上消费： {{ realMoney ? realMoney : '--' }} 
      </div>
    </div>
     
  </div>
</template>

 <script>
import { get, post, deleteFun, upload ,postJson} from '@/utils/request.js';
export default {
    data() {
        return {
          idSet:'',//团队数量
          totalMoney:'',//总业绩
          addMoney:'',//冲分业绩
          realMoney:'',//真实业绩
            queryForm: {
                phone: '',  // 手机号
                beginTime: '', 
                endTime: '', 
            },
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            storeInformationVal: {}, // 店铺信息
            timeRange:[],
        };
    },
    created() {
    },
    methods: {
        // 列表数据请求
        getBrandList() {
              //正则校验手机号
               let reg = /^1[3456789]\d{9}$/;
               if(this.queryForm.phone.trim() == ''){
                   this.$message({
                        message:'请输入手机号',
                        type: 'error',
                        duration: 2000
                    });
                    return
               }else if(!reg.test(this.queryForm.phone)){
                   this.$message({
                        message:'请输入正确的手机号',
                        type: 'error',
                        duration: 2000
                    });
                    return
               }else if(this.timeRange.length == 0){
                    this.$message({
                            message:'请输入时间',
                            type: 'error',
                            duration: 2000
                        });
                    return
               }
              if (this.timeRange) {
                  this.queryForm.beginTime = this.timeRange[0];
                  this.queryForm.endTime = this.timeRange[1];
              }else{
                  this.queryForm.beginTime = ""
                  this.queryForm.endTime = ""
              }
            this.loading = true;
            postJson(`/tianyilife/user/queryByPhone`, {
                ...this.queryForm,
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                     this.idSet = res.idSet;
                     this.totalMoney = res.totalMoney
                     this.addMoney = res.addMoney
                     this.realMoney= res.realMoney
                }else{
                    this.$message({
                          message: res.msg,
                          type: 'error',
                          duration: 2000
                      });
                }
            });
        },
        // 重置查询条件
        resetQueryFrom() {
            this.queryForm.phone = '';
            this.queryForm.beginTime = '';
            this.queryForm.endTime = '';
            this.timeRange = []
            this.idSet = ''
            this.totalMoney = ''
            this.addMoney =''
            this.realMoney=''
        },
    }
};
</script>
 
<style lang="scss" scoped>

.store_info{
  text-align: left;
  margin-left: 10%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.page-tool-bar{
    margin-top: 20px  ;
    margin-left: 30px;
    font-size: 45px;
}
</style>